var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 780,
    height: 500,
    viewBox: "0 0 780 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6278_125922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M780 0H0V500H780V0Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.828 143.11C442.993 143.11 401.138 167.392 401.138 212.256C401.138 263.706 475.369 267.259 475.369 293.107C475.369 303.99 462.9 313.732 441.604 313.732C411.381 313.732 388.793 300.119 388.793 300.119L379.127 345.391C379.127 345.391 405.149 356.89 439.697 356.89C490.903 356.89 531.196 331.415 531.196 285.785C531.196 231.418 456.656 227.97 456.656 203.98C456.656 195.455 466.892 186.113 488.127 186.113C512.086 186.113 531.634 196.013 531.634 196.013L541.093 152.288C541.093 152.288 519.824 143.11 489.828 143.11ZM61.3294 146.41L60.1953 153.01C60.1953 153.01 79.899 156.617 97.6454 163.812C120.495 172.063 122.123 176.867 125.971 191.785L167.906 353.487H224.12L310.722 146.41H254.637L198.99 287.203L176.283 167.86C174.201 154.201 163.652 146.41 150.741 146.41H61.3294ZM333.275 146.41L289.278 353.487H342.76L386.602 146.41H333.275ZM631.561 146.41C618.665 146.41 611.832 153.316 606.818 165.385L528.464 353.487H584.549L595.4 322.137H663.728L670.326 353.487H719.813L676.641 146.41H631.561ZM638.855 202.356L655.48 280.061H610.942L638.855 202.356Z",
    fill: "#1434CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6278_125922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 780,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.4d27b70e339eda0e9678303b0c94ec5c.svg";
export { ForwardRef as ReactComponent };